import React, { FunctionComponent, useState } from 'react'
import { useAppRouter, useShowIdvModal } from '../../../state'
import { Route } from '../../../config/router'
import styles from './style.module.css'
import { Button, ButtonKinds, Theme, useGetSelectedTheme, useModal } from '@afterpaytouch/core'
import { useTranslation } from '../../../utils/convergence'
import { IdentityVerificationModal } from '../../IdentityVerificationModal'
import { IdentityVerificationModalKey } from '../../../model'

export const PayMonthlyOnlyContinueButton: FunctionComponent = () => {
  const { t } = useTranslation()
  const [clicked, setClicked] = useState<boolean>(false)
  const router = useAppRouter()
  const showIDVModal = useShowIdvModal()
  const { showModal } = useModal(IdentityVerificationModalKey)
  const selectedTheme = useGetSelectedTheme()

  const handleContinueClick = (): void => {
    setClicked(true)

    if (showIDVModal) {
      showModal()
    } else {
      router.push(Route.PAYMENT_OPTIONS)
    }
  }

  const mapThemeToButton: Record<Theme, ButtonKinds> = {
    [Theme.AP]: 'Secondary',
    [Theme.Cash]: 'Secondary',
    [Theme.Pegasus]: 'Primary',
    [Theme.Kelpie]: 'Primary',
  }

  return (
    <>
      <div className={styles.continueButton}>
        <Button kind={mapThemeToButton[selectedTheme]} padding='Fluid' onClick={handleContinueClick} testNameSpace='pay-monthly-only' disabled={clicked}>
          {t('consumerLending:payMonthlyOnly:continue')}
        </Button>
      </div>
      <IdentityVerificationModal setClicked={setClicked} />
    </>
  )
}
